// extracted by mini-css-extract-plugin
export default {"wrap":"index_wrap_Sfetb fl clearfix","list":"index_list_4h4H6","qqg":"index_qqg_U6R-J"};